module.exports = __webpack_public_path__ + "img/DE06293.b7ccf5cf.png";